<template>
  <div class="container">
    <div class="user-info-list-body">
      <div>
        <el-button size="small" type="primary" @click="gotoCreateGoods"
          >创建物品</el-button
        >
      </div>
      <div>
        <p class="search-list">
          <span class="label-title">物品名称</span>
          <el-input
            size="small"
            v-model="form.name"
            placeholder="请输入商品名称"
            style="width: 200px; margin-left: 10px"
          ></el-input>
        </p>

        <p class="search-list" style="margin-left: 10px">
          <el-button size="small" type="primary" @click="onSubmitSelect"
            >查询</el-button
          >
          <el-button size="small" @click="reSize">重置</el-button>
        </p>
      </div>
      <div style="margin-top: 30px">
        <el-table
          size="small"
          :data="goodsList"
          align="center"
          style="width: 100%"
          :header-cell-style="{ background: '#f5f7fa' }"
        >
          <el-table-column prop="name" label="物品名称"> </el-table-column>

          <el-table-column prop="original_price" label="采购单价(单位:元)">
          </el-table-column>

          <el-table-column prop="present_price" label="销售单价(单位:元)"> </el-table-column>

         <el-table-column prop="unit" label="单位"> </el-table-column>


          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="gotoGoodsInfo(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="deleteGoods(scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-style">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNo"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getGoodsList,deleteGoods } from "@/api/educational";

export default {
  name: "goodsList",
  data() {
    return {
      form: {
        commodity_form: "2",
        name: "",
        page_no: "1",
        page_size: "20",
      },
      total: "1",

      goodsList: [],
      currentPage: 1,
    };
  },
  mounted() {
    this.getGoodsList();
  },
  methods: {
    //查询商品列表
    getGoodsList() {
      getGoodsList({
        name: "",
        page_no: this.form.page_no,
        page_size: this.form.page_size,
      }).then((res) => {
        console.log("商品列表");
        console.log(res);
        this.goodsList = res.goodsList;
        this.total = res.total;
      });
    },

    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    reSize() {
      console.log("重置");
      this.form = {};
      this.getGoodsList();
    },
    onSubmitSelect() {
      console.log("提交查询");

      this.getGoodsList();
    },
    gotoGoodsInfo(obj) {
      console.log(obj);
      this.$router.push({
        name: "edit-goods",
        query: {
          good: obj,
        },
      });
    },

    gotoCreateGoods() {
      // 创建商品
      this.$router.push({
        name: "add-goods",
      });
    },
    deleteGoods(id) {
      deleteGoods({
        goodsId:id
      }).then((res)=>{
        console.log("删除商品");
        console.log(res);
        if(res.is_delete)
        {
          this.$message.success("删除成功");
          this.getGoodsList();

        }
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  margin: 15px;
  border-radius: 5px;
  min-width: 1000px;
  overflow-y: scroll;
  .user-info-list-body {
    padding: 20px;
    background-color: #ffffff;
    .label-title {
      font-size: 14px;
    }
    .search-list {
      margin-top: 20px;
      display: inline-block;
    }
  }
}
</style>
